module.exports = __webpack_public_path__ + "img/marcella.7617ee6d.png";